var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11853_7559",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11853_7559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.70724 5.40156C5.4524 5.40156 5.23749 5.31581 5.06249 5.14431C4.88749 4.97281 4.79999 4.76031 4.79999 4.50681C4.79999 4.25331 4.88615 4.03906 5.05849 3.86406C5.23099 3.68906 5.44465 3.60156 5.69949 3.60156H18.2927C18.5476 3.60156 18.7625 3.68731 18.9375 3.85881C19.1125 4.03031 19.2 4.24281 19.2 4.49631C19.2 4.74981 19.1138 4.96406 18.9415 5.13906C18.769 5.31406 18.5553 5.40156 18.3005 5.40156H5.70724ZM12.0052 20.4016C11.7517 20.4016 11.5375 20.3153 11.3625 20.1428C11.1875 19.9703 11.1 19.7566 11.1 19.5016V10.6516L9.09999 12.6266C8.91666 12.8099 8.70416 12.9016 8.46249 12.9016C8.22082 12.9016 8.00832 12.8099 7.82499 12.6266C7.64166 12.4432 7.54999 12.2349 7.54999 12.0016C7.54999 11.7682 7.64049 11.5611 7.82149 11.3801L11.375 7.82656C11.465 7.74323 11.5625 7.68073 11.6675 7.63906C11.7725 7.5974 11.885 7.57656 12.005 7.57656C12.125 7.57656 12.2375 7.5974 12.3425 7.63906C12.4475 7.68073 12.5417 7.74323 12.625 7.82656L16.1552 11.3568C16.3351 11.5366 16.425 11.7474 16.425 11.9891C16.425 12.2307 16.3333 12.4432 16.15 12.6266C15.9667 12.8099 15.7583 12.9057 15.525 12.9141C15.2917 12.9224 15.0833 12.8349 14.9 12.6516L12.9 10.6516V19.5016C12.9 19.7566 12.8142 19.9703 12.6427 20.1428C12.4712 20.3153 12.2587 20.4016 12.0052 20.4016Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRed);
export default __webpack_public_path__ + "static/media/top_red.8e1eaa2856af40a40f7f44a35d0b54de.svg";
export { ForwardRef as ReactComponent };